import React, { Component } from "react";

import { ProtocolTask } from "./components/ProtocolTask";
import { LogEvent, isActivationKey } from "@learningblocks/shared-components";

import stepManager from "../../managers/stepManager";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";
import "./style.scss";

//Icons
import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";
import checkIcon from "./Tick.svg";

import backChevron from "./BackChevron.svg";
import nextChevron from "./NextChevron.svg";

export class ProtocolOptions extends Component {
  renderProgress = () => {
    return (
      <div>
        <div className="progress" aria-label="Progress steps." role="group">
          {this.renderProgressBar()}
        </div>
        <span className="progress-step">
          {stepManager.getInstance().objectiveIndex + 1}/
          {stepManager.getInstance().objectivesList.length}
        </span>
      </div>
    );
  };

  renderProgressBar = () => {
    const currentPage = stepManager.getInstance().objectivesList;

    return currentPage.map((task, index) => {
      const userInProgressStep = stepManager
        .getInstance()
        .getRealObjectiveIndex();
      const openStepIndex = stepManager
        .getInstance()
        .getCurrentObjectiveIndex();
      const isActiveStep = openStepIndex === index; // Currently open step
      const isCompletedStep = userInProgressStep > index; // Completed step
      const stepStatus = isCompletedStep ? "complete" : "incomplete";
      const isFirst = index === 0;
      const isLast = index === currentPage.length - 1;

      return (
        <LogEvent
          key={index}
          logEventProps={{
            event_type: "sim_protocol_part viewed",
            event_schema: "protocolpart",
            part_number: index,
          }}
          actionProps={{ onClick: { action: "clicked" } }}
          elementType="button"
        >
          <div
            className={`progress-bar-wrapper${isFirst ? " progress-bar-wrapper-first" : ""}${isLast ? " progress-bar-wrapper-last" : ""}`}
            onClick={() => {
              this.pageInstruction.focus();
              this.taskList.scrollTop = 0;
              stepManager.getInstance().setObjectiveByIndex(index);
            }}
            onKeyDown={(e) => {
              if (!isActivationKey(e)) return;
              this.pageInstruction.focus();
              this.taskList.scrollTop = 0;
              stepManager.getInstance().setObjectiveByIndex(index);
            }}
            key={index}
            role="button"
            tabIndex="0"
            aria-label={`Step number ${index + 1}. ${isActiveStep ? "Current" : ""} ${stepStatus}`}
            style={{
              width:
                100 / stepManager.getInstance().objectivesList.length + "%",
            }}
          >
            <div
              className={`progress-bar progress-bar-${isActiveStep ? "current" : stepStatus}${isFirst ? " progress-bar-first" : ""}${isLast ? " progress-bar-last" : ""}`}
            >
              {isCompletedStep && (
                <img
                  src={checkIcon}
                  className="checkmark"
                  alt="Well done"
                  aria-hidden="true"
                />
              )}
              <span
                className="sr-only"
                aria-current={isActiveStep ? "true" : "false"}
              >
                Step number {index + 1}. {isActiveStep ? "Current" : ""}{" "}
                {stepStatus}
              </span>
            </div>
          </div>
        </LogEvent>
      );
    });
  };

  renderPageInstructions = () => {
    if (stepManager.getInstance().objectivesList.length > 0) {
      return (
        <p
          ref={(pageInstruction) => {
            this.pageInstruction = pageInstruction;
          }}
          className="section-instruction"
        >
          {stepManager.getInstance().getCurrentObjectiveIndex() + 1}.{" "}
          {stepManager.getInstance().getCurrentObjective().objectiveText}
        </p>
      );
    } else {
      return <p className="section-instruction">0. No tasks found</p>;
    }
  };

  getAlphabetIndex = (index) => {
    if (index >= 26) {
      const upperIndex = Math.floor(index / 25);
      const delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  renderTaskPage = () => {
    // for (const step of stepManager.getInstance().getCurrentObjective()
    //     .steps) {
    //     console.log(step.stepText);
    // }
    return (
      <>
        <LogEvent
        // logEventProps={{
        //     event_type: "sim_protocol_step completed",
        //     event_schema: "protocolstep",
        //     step_number: this.getAlphabetIndex(
        //         this.props.focusedTask
        //     ),
        //     part_number: currentPage - 1,
        //     total_steps: this.props.taskPages.reduce(
        //         (count, innerArray) =>
        //             count + innerArray.tasks.length,
        //         0
        //     ),
        // }}
        // actionProps={{
        //     setTaskCompleted: { action: "complete" },
        // }}
        // elementType="button"
        >
          {this.tasks.map((task, index) => (
            <ProtocolTask
              modal={task.modal}
              key={index}
              stepIndex={index}
              pIndex={1}
              tIndex={1}
              level={"l1"}
              page={1}
              optional={
                !task.required &&
                (task.showOptionalText === undefined || task.showOptionalText)
              }
              text={task.stepText}
              buttonText={task.stepButtonText}
              current={task.current ? true : false}
              complete={task.completed ? true : false}
              skipped={
                !task.completed &&
                index < stepManager.getInstance().getCurrentStep() &&
                this.objectiveIsCurrent()
              }
              wrong={task.wrong && !task.showOptionalText ? true : false}
              taskID={task.stepID}
              tip={task.tip}
              note={task.note}
              totalTasks={this.tasks.length}
              objectiveIndex={stepManager.getInstance().objectiveIndex}
            />
          ))}
        </LogEvent>
      </>
    );
  };

  objectiveIsPassed = () => {
    if (
      stepManager.getInstance().focusedObjectiveIndex >
      stepManager.getInstance().objectiveIndex
    ) {
      return true;
    } else return false;
  };

  objectiveIsCurrent = () => {
    if (
      stepManager.getInstance().focusedObjectiveIndex ===
      stepManager.getInstance().getCurrentObjectiveIndex()
    ) {
      return true;
    } else return false;
  };

  prevBtnClass = () => {
    if (this.props.currentPage !== 1) {
      return "protocol-btn";
    } else {
      return "protocol-btn hide";
    }
  };

  finalNextBtn = () => {
    return (
      stepManager.getInstance().getCurrentObjectiveIndex() + 1 ===
      stepManager.getInstance().objectivesList.length
    );
  };

  backToNotebook = () => {
    this.props.setNoteBookSection("CONTEXT");
  };

  nextClicked = () => {
    if (this.finalNextBtn()) {
      this.props.setNoteBookSection("RESULTS");
    } else {
      stepManager
        .getInstance()
        .setObjectiveByIndex(
          stepManager.getInstance().getCurrentObjectiveIndex() + 1
        );
      this.pageInstruction.focus();
      this.taskList.scrollTop = 0;
    }
  };

  prevClicked = () => {
    stepManager
      .getInstance()
      .setObjectiveByIndex(
        stepManager.getInstance().getCurrentObjectiveIndex() - 1
      );
    this.pageInstruction.focus();
    this.taskList.scrollTop = 0;
  };

  getCurrentTaskIndicator = () => {
    let page = 1;
    let task = 1;

    for (let i = 0; i < this.props.taskPages.length; i++) {
      const taskPage = this.props.tasks[i];

      if (
        this.props.focusedTask + 1 >= task &&
        this.props.focusedTask + 1 <= task + taskPage.tasks.length
      ) {
        return (
          page +
          "." +
          String.fromCharCode(97 + (this.props.focusedTask + 1) - task)
        );
      }
      page++;
      task += taskPage.tasks.length;
    }
  };

  getCurrentTaskPage = () => {
    let page = 1;
    const task = 1;

    for (let i = 0; i < this.props.taskPages.length; i++) {
      const taskPage = this.props.tasks[i];

      if (
        this.props.focusedTask + 1 >= task &&
        this.props.focusedTask + 1 <= task + taskPage.tasks.length
      ) {
        return page;
      }
      page++;
    }
  };

  showNotesView = () => {
    this.props.toggleNotesView(true);
  };

  componentWillMount() {
    this.updateTasks();
    //Setting total pages in prep for rendering Protocol View
  }

  componentDidMount() {
    this.props.focusFirstTask();

    this.viewProtocolRead();

    stepManager.getInstance().registerNotebook(this);
  }

  viewProtocolRead = () => {
    if (this.props.viewedProtocolReadDialog === true) {
      return;
    }
    this.props.setModal({
      display: false,
      type: "PROTOCOL_READ",
      size: "md",
      connect: -1,
    });
    this.props.showModal({ display: true, shown: true });
    this.props.setViewedProtocolReadDialog({
      viewedProtocolReadDialog: true,
    });
  };

  componentDidUpdate() {
    // if(prevProps.modal.display === true && this.props.modal.display == undefined && this.props.modal.type === "PROTOCOL_READ"){
    //   this.pageInstruction.focus();
    // }

    if (stepManager.getInstance().objectivesComplete) {
      setTimeout(() => {
        this.next.scrollIntoView({ behavior: "smooth", block: "start" });
        this.next.focus();
      }, 300);
    }
  }

  updateTasks() {
    this.tasks = stepManager.getInstance().getCurrentObjective().steps;
    setTimeout(() => this.forceUpdate(), 200);
  }

  render() {
    return (
      <div>
        {/* <NotesView /> */}
        <div
          className="protocol-list-view"
          // style={{ display: this.props.notesView ? "none" : null }}
          style={{ display: null }}
        >
          <div
            className="protocol-head"
            style={{
              ...(stepManager.getInstance().objectivesList.length === 1
                ? { paddingLeft: "33px" }
                : {}),
            }}
          >
            <h4>
              {stepManager.getInstance().objectivesList.length > 1 && (
                <>
                  <div className="hexagon">
                    <IconHexagon
                      style={{
                        position: "absolute",
                        top: "22px",
                        left: "16px",
                        color: "white",
                        height: "29px",
                      }}
                    />
                  </div>
                  <span className="listIndex">
                    {this.props.sectionOption.number}
                  </span>
                </>
              )}
              <button
                aria-label="Protocol menu button. Select to hide the Protocol instructions and simulation and display the menu."
                className="protocol-title-btn"
                onClick={this.backToNotebook}
              >
                Protocol
              </button>
              {this.props.displayProgress && this.props.protocolMenuItem && (
                <span className="protocol-progress-text">
                  {this.props.protocolMenuItem.currentProgress !== undefined
                    ? this.props.protocolMenuItem.currentProgress
                    : 0}
                  /
                  {this.props.protocolMenuItem.maxProgress !== undefined
                    ? this.props.protocolMenuItem.maxProgress
                    : 100}
                </span>
              )}
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_open_notes_btn clicked",
                  event_schema: "track",
                }}
                actionProps={{ onClick: { action: "click" } }}
                elementType="button"
              ></LogEvent>
            </h4>
          </div>
          {stepManager.getInstance().objectivesList.length > 1 && (
            <div className="protocol-progress-container">
              {this.renderProgress()}
              {this.renderPageInstructions()}
            </div>
          )}
          <div
            className="protocol-content"
            ref={(taskList) => {
              this.taskList = taskList;
            }}
          >
            <div className="protocol-tasks-container">
              <ul>{this.renderTaskPage()}</ul>
            </div>
            <div className="protocol-btns-container">
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_previous_part_btn clicked",
                  event_schema: "protocolpart",
                  part_number: this.props.focusedPage,
                }}
                actionProps={{ onClick: { action: "clicked" } }}
                elementType="button"
              >
                <button
                  aria-label="Previous button. Select to display the previous step in the protocol."
                  className={this.prevBtnClass()}
                  onClick={this.prevClicked}
                  style={{
                    visibility:
                      stepManager.getInstance().getCurrentObjectiveIndex() === 0
                        ? "hidden"
                        : "visible",
                  }}
                >
                  {/* <IconStart
                    style={{
                      color: colors.navy1,
                      height: "16px",
                      top: "2px",
                      transform: "rotate(180deg)",
                    }}
                  />{" "} */}
                  <img
                    style={{ marginRight: "10px" }}
                    src={backChevron}
                    alt="Previous"
                  />
                  Previous
                </button>
              </LogEvent>
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_part viewed",
                  event_schema: "protocolpart",
                  part_number: this.props.focusedPage,
                }}
                actionProps={{ onClick: { action: "clicked" } }}
                elementType="button"
              >
                <div
                  role="button"
                  tabIndex={0}
                  className="indicator"
                  aria-label={(() => {
                    const realObjectiveIndex = stepManager
                      .getInstance()
                      .getRealObjectiveIndex();
                    const allObjectives = stepManager
                      .getInstance()
                      .getAllObjectives();
                    const currentStep = stepManager.getInstance().currentStep;
                    const stepNumber =
                      realObjectiveIndex != -1
                        ? realObjectiveIndex + 1
                        : allObjectives.length;
                    const stepLetter = this.getAlphabetIndex(currentStep);
                    const stepIndicator = stepNumber + "." + stepLetter;
                    return `Current step is ${stepIndicator}. Select to return to the current step.`;
                  })()}
                  onClick={() => {
                    stepManager
                      .getInstance()
                      .setObjectiveByIndex(
                        stepManager.getInstance().focusedObjectiveIndex
                      );
                  }}
                  onKeyDown={(e) => {
                    if (!isActivationKey(e)) return;
                    stepManager
                      .getInstance()
                      .setObjectiveByIndex(
                        stepManager.getInstance().focusedObjectiveIndex
                      );
                  }}
                >
                  {(() => {
                    const realObjectiveIndex = stepManager
                      .getInstance()
                      .getRealObjectiveIndex();
                    const allObjectives = stepManager
                      .getInstance()
                      .getAllObjectives();
                    const currentStep = stepManager.getInstance().currentStep;
                    const stepNumber =
                      realObjectiveIndex != -1
                        ? realObjectiveIndex + 1
                        : allObjectives.length;
                    const stepLetter = this.getAlphabetIndex(currentStep);
                    const stepIndicator = stepNumber + "." + stepLetter;

                    return (
                      <>
                        <span className="sr-only">
                          Current step is {stepIndicator}. Select to return to
                          the current step.
                        </span>
                        <span aria-hidden="true">{stepIndicator}</span>
                      </>
                    );
                  })()}
                  <IconHexagon
                    aria-hidden="true"
                    style={{
                      color: colors.navy1,
                      height: "46px",
                    }}
                  />
                </div>
              </LogEvent>
              <LogEvent
                logEventProps={{
                  event_type: "sim_protocol_next_part_btn clicked",
                  event_schema: "protocolpart",
                  part_number: this.props.focusedPage,
                }}
                actionProps={{ onClick: { action: "clicked" } }}
                elementType="button"
              >
                <button
                  aria-label="Next button. Select to display the next step in the protocol."
                  className={
                    "protocol-btn" +
                    (stepManager.getInstance().getRealObjectiveIndex() >
                      stepManager.getInstance().getCurrentObjectiveIndex() ||
                    stepManager.getInstance().objectivesComplete
                      ? "  protocol-final-btn"
                      : "") +
                    (this.props.focusedPage >= this.props.currentPage ||
                    (this.props.currentPage === this.props.totalPages &&
                      this.props.taskPages[this.props.focusedPage].complete ===
                        true)
                      ? " active"
                      : "")
                  }
                  onClick={this.nextClicked}
                  ref={(next) => {
                    this.next = next;
                  }}
                >
                  {/* <IconStart
                    style={{
                      color: colors.navy1,
                      height: "16px",
                      top: "2px",
                    }}
                  /> */}
                  {this.finalNextBtn() ? "Results" : "Next "}
                  <img
                    style={{ marginLeft: "10px" }}
                    src={nextChevron}
                    alt="Next"
                  />
                </button>
              </LogEvent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProtocolOptions.defaultProps = {
  tasks: [],
};
